import { SearchRegistry } from '../types';

export const troubleshootingSearchEntries: SearchRegistry = {
  '/troubleshooting/pois-and-shops/station-status': {
    keywords: [
      'station status',
      'station online',
      'station offline',
      'shop online',
      'shop offline',
      'checkmk',
      'station heartbeat',
      'price status',
      'monitoring',
      'poi status',
      'station history',
      'offline history',
      'station availability',
      'station outages',
      'station uptime',
    ],
    questions: [
      'Is this station online or offline?',
      'When was a station last checked?',
      'Is the station online but missing current prices?',
      'Where can I see the Checkmk status for a shop?',
      'How often was this station offline in the last days?',
      'What is the availability of this station?',
    ],
  },
  '/troubleshooting/pois-and-shops/search': {
    keywords: [
      'search places',
      'search pois',
      'search shops',
      'station address',
      'shop address',
      'place address',
      'shop brand',
      'tt4 places',
      'production places',
      'staging places',
    ],
    questions: [
      'How do I find a shop ID by address?',
      'How do I search TT4 places in production or staging?',
      'Where can I find all shops inside a place?',
    ],
  },
  '/troubleshooting/pois-and-shops/shop-details': {
    keywords: [
      'shop lookup',
      'shop details',
      'shop id',
      'place shop',
      'poi shop',
      'vending machines',
      'available products',
      'shop products',
      'shop prices',
      'tt4',
      'production shop',
      'staging shop',
    ],
    questions: [
      'How do I look up a shop by shop ID?',
      'Where can I see the vending machines, products and prices for a shop?',
      'How do I inspect the complete raw shop record?',
    ],
  },
  '/troubleshooting/order-details': {
    keywords: [
      'order investigation',
      'order details',
      'order debugging',
      'order trace',
      'order timeline',
      'investigate order',
      'troubleshoot order',
      'order forensic',
      'failed order analysis',
      'bestelldetails',
      'order summary tab',
      'action codes tab',
      'actioncodes tab',
      'action code tab',
      'actioncode tab',
      'error codes tab',
      'errorcodes tab',
      'error code tab',
      'errorcode tab',
      'pop events tab',
      'api state events',
      'api gateway http requests',
      'partner system interactions',
      'ryd webhook requests',
      'user agents tab',
      'ev charges tab',
      'error log messages',
      'user sponsor details',
      'inclusive date',
      'staging or production',
      'order uuid search',
    ],
    questions: [
      'How do I investigate why an order failed?',
      'Where do I see the full timeline of an order?',
      'How do I trace an order across services?',
      'How do I see API gateway requests for an order?',
      'How do I see all webhook attempts ryd sent for an order?',
      'Where do I see partner system interactions for one order?',
    ],
    faqs: [
      {
        q: 'How do I investigate a failed order?',
        a: 'Open Troubleshooting → Order Investigation and paste the order UUID. The page exposes a tabbed view: Summary, Action Codes, POP Events, API State Events, API Gateway HTTP Requests, Partner System Interactions, ryd Webhook Requests, User Agents, EV Charges, Error Log Messages and User/Sponsor Details — enough to root-cause most failures.',
      },
      {
        q: 'Can I look up an order from staging from the same page?',
        a: 'Yes — the Order Investigation search accepts UUIDs from both staging and production; the page detects which environment the UUID belongs to automatically and surfaces the appropriate data.',
      },
    ],
  },
  '/troubleshooting/account-activities': {
    keywords: [
      'account activities',
      'user activity',
      'activity log',
      'account events',
      'user actions',
      'audit log',
      'kontoaktivität',
      'account na activities',
      'available orders tab',
      'account metadata tab',
      'account history',
    ],
    questions: [
      'How do I see what a customer did recently?',
      'Where is the account activity log?',
      'How do I see which orders an account has access to?',
    ],
  },
  '/troubleshooting/account-activity-timeline': {
    keywords: [
      'account activity timeline',
      'activity timeline',
      'user timeline',
      'event timeline',
      'audit timeline',
      'chronological activity',
      'account events stream',
      'account event log',
    ],
    questions: [
      "How do I see a chronological timeline of a customer's account activity?",
      'Where do I open the account activity timeline?',
      'How do I correlate auth, order and payment events for a single account?',
    ],
  },
  '/troubleshooting/pois-and-shops/price-updates': {
    keywords: [
      'price updates',
      'price update log',
      'price change history',
      'station price updates',
      'pump price changes',
      'price feed log',
      'price update tab',
      'price audit',
      'price change events',
    ],
    questions: [
      'When did station prices last update?',
      'Where do I see the price-update history per station?',
      'Why did a station price not update overnight?',
    ],
  },
};
